exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".fileInputRemoveIcon__1oHBE{color:#096dd9;margin-left:1.5rem;padding-top:.4rem;cursor:pointer;display:inline-block;vertical-align:middle}", "", {"version":3,"sources":["/home/runner/work/web-support-widget/web-support-widget/src/components/FormFields/index.scss"],"names":[],"mappings":"AAAA,4BACE,cACA,mBACA,kBACA,eACA,qBACA,qBAAsB,CACvB","file":"index.scss","sourcesContent":[".fileInputRemoveIcon {\n  color: #096dd9;\n  margin-left: 1.5rem;\n  padding-top: 0.4rem;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"fileInputRemoveIcon": "fileInputRemoveIcon__1oHBE"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/FormFields/index.scss
// module id = cZIY
// module chunks = 0